import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { UserServiceService } from "../../service/user-service.service";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CustomValidators } from "../../CustomValidators";
import { ErrorMessages } from "../../model/error-messages.enum";
import { PermissionService } from "../../service/permission.service";
import { UserGroupInvite } from "../../model/userGroupInvite";

@Component({
  selector: 'app-invites',
  templateUrl: './invites.component.html',
  styleUrls: ['./invites.component.css']
})
export class InvitesComponent implements OnInit {

  userForm: UntypedFormGroup;
  toNextPage: boolean = false;
  errorMessage: string;
  isValid: boolean = false;
  invite: UserGroupInvite;
  loading: boolean = true;

  constructor(private formBuilder: UntypedFormBuilder,
              private userService: UserServiceService,
              private permissionService: PermissionService,
              private router: Router,
              private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.userForm = this.formBuilder.group({
      title: new UntypedFormControl("", Validators.required),
      firstname: new UntypedFormControl("", Validators.required),
      lastname: new UntypedFormControl("", Validators.required),
      mail: new UntypedFormControl("", Validators.required),
      password: new UntypedFormControl(null, Validators.compose([
        Validators.required,
        CustomValidators.patternValidator(/^(?=.*[0-9])/g,{hasNumber:true}),
        CustomValidators.patternValidator(/^(?=.*[a-z])/g,{hasSmallLetter:true}),
        CustomValidators.patternValidator(/^(?=.*[A-Z])/g,{hasBigLetter:true}),
        CustomValidators.patternValidator(/^(?=.*[_\-!?.@#$%^&*])/g,{hasSpecialCharacter:true}),
        Validators.minLength(8)
      ])),
      passwordConfirm: new UntypedFormControl(null, Validators.required)
    }, {validators: [CustomValidators.passwordMatchValidator]});

    this.route.params.subscribe(async (params: Params) => {
      const token = params['token'];
      this.isValid = await this.validateToken(token).then(res => {
        this.loading = false;
        this.userForm.get('mail').setValue(this.invite.mail);
        return res;
      });
    })
  }

  doRegister() {
    this.toNextPage = true;
    if (this.userForm.valid) {
      this.userService.saveWithInvitation(this.userForm.value, this.invite.token).subscribe(res => {
        if(res == null) { // if we do not get a User Object it means the user already exists
          this.errorMessage = ErrorMessages.USER_EXIST;
        } else {
          this.router.navigate(['/register/success']);
        }
      },
      error => {
        this.errorMessage = "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
      });
    } else
      this.errorMessage = "Formular nicht vollständig ausgefüllt oder ungültige Eingaben!";
  }

  hasError(control: AbstractControl): boolean {
    return (control.invalid && (control.touched || this.toNextPage));
  }

  validateToken(token: string) : Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.permissionService.verifyToken(token).subscribe(invite => {
        this.invite = invite;
        resolve(this.invite.status === 'PENDING');
      }, error => {
        console.log(error);
        reject(false);
      }
      );
    });
  }
}
